import { IUser } from './user.interface';

export interface IUserAPI {
    keyword: string,
    message: string,
    user: IUser,
    pageSize?: number;
    page?: number;
}